import { useEffect } from 'react';
import styles from '@/shared/ui/Loader.module.css';
import { UpminiLogo } from '@/shared/ui/UpminiLogo';

type LoaderProps = {
  isFadingOut?: boolean;
  isHeartbeat?: boolean;
  statusText?: string;
};

export function Loader({
  isFadingOut = false,
  isHeartbeat = false,
  statusText = 'Подготавливаем приложение',
}: LoaderProps): JSX.Element {
  useEffect(() => {
    const startupStatus = document.getElementById('startup-status');
    if (startupStatus) startupStatus.textContent = statusText;
  }, [statusText]);

  return (
    <div className={`${styles.loaderWrapper} ${isFadingOut ? styles.fadeOut : ''}`} data-app-loading-screen role="status" aria-live="polite" aria-label={statusText}>
      <div className={styles.background} />
      <UpminiLogo
        className={`${styles.logo} ${isHeartbeat ? styles.heartbeat : ''}`}
        basePathClassName={styles.basePath}
        animatedPathClassName={styles.animatedPath}
      />
      <div className={styles.progressPanel}>
        <span>{statusText}</span>
        <div className={styles.track} role="progressbar" aria-label="Подготовка приложения">
          <div className={styles.indeterminate} />
        </div>
      </div>
    </div>
  );
}
